<template>
  <div
    class="wf-flex wf-flex-wrap wf-justify-between wf-w-full wf-py-2 wf-items-center"
  >
    <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">{{ text }}</span>
    <div class="wf-w-1/2">
      <select v-model="value" class="wf-w-full">
        <option :value="item.value" v-for="(item, key) in items" v-bind:key="key">{{ item.text }}</option>
      </select>
    </div>
  </div>
</template>

<script>
  import MenuContentProperty from '../contracts/MenuContentProperty'
  import _ from 'lodash'
  export default MenuContentProperty.extend({
    props: {
      items: {
        type: [Object, Array],
        required: true,
        default: () => {
          return {
            'value': 'Text'
          }
        }
      },
      property: {
        type: String,
        required: false,
        default: 'text'
      },
      text: {
        type: String,
        required: false,
        default: 'text'
      }
    },
    computed: {
      value: {
        get() {
          return this.elementContent[this.property]
        },
        set: _.debounce(function (value) {
          let object = new Object
          this.$set(object, this.property, value)
          this.addToObject(this.module, object, 'content', null, {}, true, this.parentModule)
        }, 50)
      },
    }
  })
</script>
